class Oswald {
  static designing: boolean = false;

  static isDesigning(): boolean {
    return this.designing;
  }

  static setDesigning(designing: boolean): void {
    this.designing = designing;
  }
}

export default Oswald;
